<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
    <div class="comment-box">
        <div class="user-comment" v-if="comment"  :class="layersCount<=3 ? 'user-comment-one' : 'user-comment-two'">
            <div class="user-comment-content img-content" v-if="layersCount<=3">
                <div class="line"></div>
                <img v-if="comment.admin_details && comment.admin_details.file" width="50" height="50" :src="$store.state.base_urls.adminsUploads+ comment.admin_details.file" alt="">
                <img v-else-if="comment.user_type === 'admin'" width="50" height="50" src="../assets/defaults/man.jpg" alt="">
                <img v-else width="50" height="50" src="../assets/defaults/profile.jpg" alt="">
            </div>
            <div class="user-comment-content main-comment-content" :class="layersCount<=3 ? 'comment-content-one' : 'comment-content-two'">
                <div class="main-comment-content-section-one">
                    <div class="title">
                        <div class="title-section-one"  v-if="comment.admin_details">
                            {{comment.admin_details.name}}
                        </div>
                        <div class="title-section-one"  v-else-if="comment.user_details">
                            {{comment.user_details.name}}
                        </div>
                        <div class="title-section-one"  v-else>
                            <span v-if="comment.user_type === 'admin'">
                                کارشناس سیستم
                            </span>
                            <span v-else>
                                کاربر سیستم
                            </span>
                        </div>
                        <div class="title-section-two">
                           {{comment.sending_time}}
                        </div>
                        <span v-if="layersCount>3" class="reply-to-user-name">
                            در جواب
                            @
                            <span v-if="replyTo.admin_details">
                                {{replyTo.admin_details.name}}
                            </span>
                            <span  v-else-if="replyTo.user_details">
                                {{replyTo.user_details.name}}
                            </span>
                            <span v-else>
                            <span v-if="replyTo.user_type === 'admin'">
                                کارشناس سیستم
                            </span>
                                <span v-else>
                                کاربر سیستم
                            </span>
                            </span>
                        </span>
                    </div>

                    <div class="comment-body">
                        {{comment.comment}}
                    </div>

                </div>
                <div class="main-comment-content-section-two" >
                    <div>
                        <ul class="reply-icon">
                            <li  v-if="loginStatus" class="reply-icon-img">
                                <img width="24" height="18" src="../assets/new/Icon/Reply.png" alt="">
                            </li>
                            <li v-if="loginStatus" class="reply-icon-txt" @click="showFormToggle">
                                <span>
                                    پاسخ
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div class="like-box" v-if="likesDetails">
                            <div  class="like-box-container"   v-on:click="handleLikingPost(1)">
                                 <span>  {{likesDetails.likes_count}}</span>
                                <img v-if="likesDetails.current_user_like.status=='1'" width="20" height="20"  src="../assets/new/New/Icon/LikeGreen.png" alt="">
                                <img v-else width="20" height="20"  src="../assets/new/New/Icon/Like.png" alt="">
                            </div>
                            <div class="unlike-box-container"   v-on:click="handleLikingPost(0)">
                                <span>{{likesDetails.unlikes_count}}</span>
                                <img class="unlike" v-if="likesDetails.current_user_like.status=='0'" width="20" height="20"  src="../assets/new/New/Icon/LikeGreen.png" alt="">
                                <img class="unlike" v-else width="20" height="20"  src="../assets/new/New/Icon/Like.png" alt="">
                            </div>
                        </div>
                        <div class="like-box" v-else>
                            <div  class="like-box-container"   v-on:click="handleLikingPost(1)">
                                <span>  {{comment.likes_count}}</span>
                                <img v-if="comment.current_user_like.status=='1'" width="20" height="20"  src="../assets/new/New/Icon/LikeGreen.png" alt="">
                                <img v-else width="20" height="20"  src="../assets/new/New/Icon/Like.png" alt="">
                            </div>
                            <div class="unlike-box-container"   v-on:click="handleLikingPost(0)">
                                <span>{{comment.unlikes_count}}</span>
                                <img class="unlike" v-if="comment.current_user_like.status=='0'" width="20" height="20"  src="../assets/new/New/Icon/LikeGreen.png" alt="">
                                <img class="unlike" v-else width="20" height="20"  src="../assets/new/New/Icon/Like.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="loginStatus">
                    <transition name="fade">
                        <div v-if="showCommentForm" class="main-comment-content-section-four">
                            <CommentForm :type="type" :slug="slug" :parentId="comment.id"/>
                        </div>
                    </transition>
                </div>


                <div  v-if="comment.presentable_replies && layersCount<3" class="main-comment-content-section-tree" style="width: 100%;padding: 30px 0;height: auto">
                    <div v-for="reply in comment.presentable_replies" :key="reply">
                        <UserComment :type="type" :replyTo="comment" :layersCount="layersCount+1" :comment="reply" :slug="slug"/>
                    </div>
                </div>
                <div class="comment-body">
                    <div  v-if="comment.presentable_replies && layersCount>=3" style="width: 100%;padding: 30px 0;height: auto">
                        <div v-for="reply in comment.presentable_replies" :key="reply">
                            <UserComment :type="type" :layersCount="layersCount+1"  :replyTo="comment" :comment="reply" :slug="slug"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div  v-if="layersCount<3" class="comment-space">
                <div class="comment-space-line"></div>
        </div>

    </div>
</template>

<script>
    // import UserComment from './UserComment'
    import Alert from '../components/Alert'
    import CommentForm from  '../components/CommentForm'
    import axios from 'axios'
    export default {
        name: "UserComment",
        props:['comment','presentable_replies','slug','layersCount','replyTo','type'],
        data(){
          return {
              showCommentForm:false,
              alertContent: null,
              loadingMood: false,
              likesDetails:null,
              loginStatus: this.$store.state.loginStatus,
          }
        },
        components:{
            // UserComment
            CommentForm,
            Alert,
        },
        methods:{
            showFormToggle(){
                if(this.showCommentForm===false){
                    this.showCommentForm=true
                }else{
                    this.showCommentForm=false
                }
            },
            async handleLikingPost(status){
                try {
                    this.loadingMood = true;
                    let response = await axios.post('api/commentChangingLikingStatus/' + this.comment.id + '/' + status);
                    this.loadingMood = false;
                    this.likesDetails = response.data.likesDetails;
                    console.log(this.likesDetails)
                } catch (error) {
                    console.log(error)
                }
            },
        },
        created() {

        },
    }
</script>

<style lang="scss" scoped>
    .user-comment-two{
        //padding-right: 25px;
    }
    .reply-to-user-name{
        color: lightcoral;
    }
    .comment-space{
        width: 100%;
        height: 50px;
        position: relative;
        .comment-space-line{
            position: absolute;
            width: 2px;
            height: 100%;
            right: 25px;
            background-color: #dfdfdf;
        }
    }
    .main-comment-content-section-four{
        width: 100%;
        height: auto;
        padding-top: 20px;
    }
    .unlike-box-container{
        border-right: 2px solid #bbc5d6;
        text-align: left;
        width: 45px!important;
        cursor: pointer;
    }
    .like-box-container{
        cursor: pointer;
    }
    .unlike{
        transform: rotate(180deg);
    }
    .comment-submit-btn{
        max-width: 350px;
        width: 90%;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .comment-box{
        width: 100%;
        height: auto;
        padding: 0;
    }
    .iconify{
        font-size: 24px;
    }
    .like-box{
        float: left;
        display: flex;
        justify-content: center;
        line-height: 30px!important;
        max-width: 120px !important;
        min-width: 80px;
        div{
            /*background-color: goldenrod!important;*/
            display: flex!important;;
            justify-content: center!important;;
            align-items: center!important;;
            line-height: 30px;
            span{

                margin-left: 5px;
            }
        }
    }


    .main-comment-content-section-two{
        padding-top: 10px;
        justify-content: center;
        display: flex;
        div{
            height: 30px!important;
            width: 50%;
            /*background-color: darkmagenta;*/
        }
    }

    .like-icon{
        div{
            display: inline-block;
            height: 50px;
            /*background-color: chartreuse;*/
        }
    }
    .reply-icon-img{
        margin-right: -25px;
    }
    .reply-icon-txt{
        margin-right: 5px;
    }
    .reply-icon{
        cursor: pointer;
        list-style-type: none;
        width: auto;
        li{
            float: right;
            display: inline-block;
            font-family: IRANSans;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: justify;
            color: rgba(110,110,110,0.5);
        }
    }
    .comment-body{

        font-family: IRANSans;

        font-size: 14px;

        font-weight: normal;

        font-stretch: normal;

        font-style: normal;

        line-height: normal;

        letter-spacing: normal;

        text-align: right;

        color: #1a1a1a;
    }
    .main-comment-content-section-one{
        width: 100%;
        height: auto;
        /*background-color: brown;*/
    }
    .title-section-one{
        text-align: right;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
    }
    .title-section-two{
        font-size: 15px;
        text-align: left;
    }
    .title{
        /*background-color: red;*/
        width: 100%;
        height: 50px;
        div{
            width: 50%;
            display: inline-block;
        }
    }
    .main-comment-content{
        padding-right: 10px;
        /*background-color: #262626;*/

        height: auto;
        div{
            height: auto;
        }
    }
    .comment-content-one{
        width: calc(100% - 50px);
    }
    .comment-content-two{
        padding: 0;
        width: 100%;
    }
    .img-content{
        position:relative ;
        z-index: 0;
        img{
            border-radius: 50%;
            z-index: 1;
            position: relative;
        }
        width: 50px;
        height: auto;
        .line{
            position: absolute;
            width: 2px;
            height: 100%;
            right: 25px;
            background-color: #dfdfdf;
        }
        /*background-color: #4285f4;*/
    }
    .user-comment-content{
        display: inline-block;
    }
    .user-comment{
        display: flex;
        justify-content: center;
        /*background-color: #262626;*/
        width: 100%;
        height: auto;
    }
    .form-container{
        /*display: none;*/
        display: flex;
        /*display: none;*/
        margin-top: 20px;
        justify-content: center;
        align-items: center;
    }
    button{
        width: 369px;
        height: 54px;
        margin: auto;
        background-color: #162336;
        color: white;
        border: solid 1px #979797;
        border-radius: 10px;
        transition: 0.1s all;
    }
    button:hover{
        background-color: #fe7063;
        color: white;
    }
    #email-input{
        text-align: left;
        padding-right: 15px;
    }
    .text-field {
        position: relative;
        margin: 10px 2.5px 20px 2.5px;
    }
    input:focus {
        border: thin solid #32cd32;
        border-bottom: solid medium #32cd32;
        background-color:#fff;
    }
    label {
        position: absolute;
        pointer-events: none;
        right: 10px;
        top: 5px;
        transition: 0.2s;
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        opacity: 1;
    }
    input:focus ~ label, input:valid ~ label {
        top: -12px;
        right: 15px;
        font-size: small;
        color:  #fe7063;
        padding:0 5px 0 5px;
        background-color: white;

    }
    input{
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        max-width: 300px;
        width: 100%;
        height: 40px;
        border-radius: 5px!important;
        opacity: 0.5;
        border: solid 0.5px #162336;
    }
    input:focus{
        border: solid 2px #fe7063!important;
    }
    *:focus {
        border: solid 0.5px #162336!important;
    }
    textarea:focus{
        border: solid 2px #fe7063!important;
    }


</style>